import { ModelBase } from 'store/model-base';

export class CmsLevelMovePending extends ModelBase {
    public static storeName: string = 'cmsLevelMovePending';

    public pageTitle: string;
    public header: string;
    public subhead: string;
    public cta: string;
    public disclaimer: string;
    public fiveGIcon: CmsMediaImage;
    public envelopeIcon: CmsMediaImage;
}
